import React, { useEffect, useRef } from 'react';
import { Box, Button, styled, themeGet } from '@qwealth/qcore';
import { ReactElement, useState } from 'react';

interface TruncateTextProps {
  text: string;
  textHeight?: string;
}
const StyledContainer = styled(Box)<{ $textHeight?: string }>`
  position: relative;
  width: 100%;
  min-height: ${props => props.$textHeight};
`;

const StyledTextTruncate = styled(Box)<{ $textHeight?: string; $showText?: string }>`
  word-break: break-all;
  max-height: ${props => (props.$showText === 'visible' ? 'auto' : props.$textHeight)};
  overflow-y: ${props => props.$showText};
`;

const StyledButtonContainer = styled(Box)<{ $showText?: string }>`
  position: absolute;
  bottom: ${props => (props.$showText === 'visible' ? '-20px' : '0')};
  right: 0;
  background: ${props => (props.$showText === 'visible' ? 'transparent' : 'linear-gradient(to bottom, transparent, white 70%)')};
  padding-top: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const TruncateTextByTextHeight: React.FC<TruncateTextProps> = ({ text, textHeight = '100px' }): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const scrollHeight = textRef.current.scrollHeight;
      const maxHeight = parseInt(textHeight, 10);
      setShouldShowButton(scrollHeight > maxHeight);
    }
  }, [text, textHeight]);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <StyledContainer>
      <StyledTextTruncate
        ref={textRef}
        dangerouslySetInnerHTML={{ __html: text }}
        $textHeight={textHeight}
        $showText={isExpanded ? 'visible' : 'hidden'}
      />

      {shouldShowButton && (
        <StyledButtonContainer $showText={isExpanded ? 'visible' : 'hidden'}>
          <Button variant="text" size="small" onClick={toggleText}>
            {isExpanded ? 'Show Less' : 'Show More'}
          </Button>
        </StyledButtonContainer>
      )}
    </StyledContainer>
  );
};
export default TruncateTextByTextHeight;
